import _styled from "styled-components";
import { Fragment, useMemo } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import Forward10 from '@crehana/icons/Forward10';
import Pause from '@crehana/icons/Pause';
import PlayArrow from '@crehana/icons/PlayArrow';
import Replay from '@crehana/icons/Replay';
import Replay10 from '@crehana/icons/Replay10';
import { useHlsContext } from "../context/Hls";
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import { CircularButton, MiddleButton } from "./ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MiddleControls = function MiddleControls() {
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    isStarted = _usePlaybackContext.isStarted,
    isEnded = _usePlaybackContext.isEnded,
    isPlaying = _usePlaybackContext.isPlaying,
    togglePlay = _usePlaybackContext.togglePlay,
    replay = _usePlaybackContext.replay,
    onBackward = _usePlaybackContext.onBackward,
    onForward = _usePlaybackContext.onForward,
    disableSeekForward = _usePlaybackContext.disableSeekForward;
  var _useHlsContext = useHlsContext(),
    currentQualityWarning = _useHlsContext.currentQualityWarning;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi,
    hideSkipButtons = _useUIContext.hideSkipButtons;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var middleAction = useMemo(function () {
    if (isEnded) {
      return {
        icon: Replay,
        action: replay,
        label: t('REPLAY_LABEL')
      };
    }
    return {
      icon: isPlaying ? Pause : PlayArrow,
      action: togglePlay,
      label: isPlaying ? t('PAUSE_LABEL') : t('PLAY_LABEL')
    };
  }, [isEnded, isPlaying, replay, togglePlay, t]);
  if (playerSize.matches.md) {
    return null;
  }
  var marginBetweenButtons = playerSize.matches.xs ? '96px' : '56px';
  if (playerSize.matches.sm) {
    marginBetweenButtons = '112px';
  }
  return /*#__PURE__*/_jsx(_StyledDiv, {
    className: cn('cp-middle-controls absolute flex items-center', visibleUi && !currentQualityWarning ? ' opacity-1 z-4' : ' opacity-0 z-3'),
    children: hideSkipButtons ? /*#__PURE__*/_jsx(CircularButton, {
      icon: {
        component: middleAction.icon
      },
      onClick: middleAction.action,
      "aria-label": middleAction.label,
      isXxs: playerSize.value === 'xxs'
    }) : /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(MiddleButton, {
        icon: {
          component: Replay10
        },
        onClick: onBackward,
        disabled: !isStarted,
        style: {
          marginRight: marginBetweenButtons
        },
        "aria-label": t('BACKWARD_LABEL')
      }), /*#__PURE__*/_jsx(MiddleButton, {
        icon: {
          component: middleAction.icon
        },
        onClick: middleAction.action,
        "aria-label": middleAction.label
      }), !disableSeekForward && /*#__PURE__*/_jsx(MiddleButton, {
        icon: {
          component: Forward10
        },
        onClick: onForward,
        disabled: isEnded,
        style: {
          marginLeft: marginBetweenButtons
        },
        "aria-label": t('FORWARD_LABEL')
      })]
    })
  });
};
export default MiddleControls;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-tbax1i-0"
})(["\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        transition: ", ";\n      "], function (_ref) {
  var theme = _ref.theme;
  return theme.transition('opacity', 300);
});